namespace Matrix.Administration {
    export interface UserGroupRow {
        GroupId?: string;
        Username?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        GroupName?: string;
    }

    export namespace UserGroupRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Administration.UserGroup';
        export const deletePermission = 'Administration:Security';
        export const insertPermission = 'Administration:Security';
        export const readPermission = 'Administration:Security';
        export const updatePermission = 'Administration:Security';

        export declare const enum Fields {
            GroupId = "GroupId",
            Username = "Username",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            GroupName = "GroupName"
        }
    }
}
